import { Link } from 'react-router-dom';
import { EmptyState } from '../components/states';
import { t } from '../i18n/pt-BR';

export function NotFoundPage() {
  return (
    <div className="wrap" style={{ paddingBlock: 40 }}>
      <EmptyState
        title={t.states.notFoundTitle}
        action={
          <Link className="btn" to="/">
            {t.states.backHome}
          </Link>
        }
      >
        {t.states.notFound}
      </EmptyState>
    </div>
  );
}
